<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct1" id="toc_marker-4"><a href="#/OEBPS/Return_of_the_Raven_Mocker2#Contents-A">Cast of Characters</a></p>
<p class="cast-level">Alafair Tucker—Takes care of everyone even if they don’t ask</p>
<p class="cast-level">Shaw Tucker—Her husband, in charge of everything, more or less</p>
<p class="cast-level1"><span class="char-style-override">Their children</span><em class="italic">:</em></p>
<p class="cast-level2">Martha McCoy—age 27, President of Boynton Red Cross Chapter</p>
<p class="cast-level3">Major Streeter McCoy—her husband, in Washington D.C., winning the war</p>
<p class="cast-level">Mary Lucas—age 25, keeping quarantine</p>
<p class="cast-level3">Sergeant Kurt Lucas—her husband, in Washington D.C., translating German documents</p>
<p class="cast-level3">Judy Lucas—age 33 months, their daughter</p>
<p class="cast-level">Alice Kelley—age 24, feeling poorly</p>
<p class="cast-level3">Walter Kelley—her husband, also feeling poorly</p>
<p class="cast-level3">Linda Kelley—age 27 months, their daughter</p>
<p class="cast-level">Phoebe Day—age 24, Alice’s twin, taking care of her father</p>
<p class="cast-level3">John Lee Day—her husband, running the farm</p>
<p class="cast-level3">Zeltha Day—age 4, their daughter</p>
<p class="cast-level3">Tucker Day—age 26 months, their son</p>
<p class="cast-level">Lt. George W. Tucker, also known as Gee Dub—age 22, in France</p>
<p class="cast-level">Ruth Tucker—age 19, taking care of her mentor</p>
<p class="cast-level3">Seaman Trenton Calder, Ruth’s intended, somewhere in the North Atlantic</p>
<p class="cast-level">Private Charlie Tucker—age 17, driving trucks in England, whether he ought to be or not</p>
<p class="cast-level">Blanche Tucker—age 13, wrangling babies</p>
<p class="cast-level">Sophronia Tucker—age 12, causing trouble</p>
<p class="cast-level">Grace Tucker—age 6, or close enough to make no difference</p>
<p class="cast-level4">Members of the family:</p>
<p class="cast-level2">Chase Kemp—age 8, Alafair’s nephew and ward, a talented spy</p>
<p class="cast-level">Scott Tucker—the law in Boynton, Oklahoma, Shaw’s cousin</p>
<p class="cast-level">Hattie Tucker—Scott’s wife</p>
<p class="cast-level">Slim Tucker—their son, Scott’s deputy</p>
<p class="cast-level4">No relation, but God’s children all the same:</p>
<p class="cast-level2">Wesley M. Cotton—prosecuting attorney, District Court of Muskogee County</p>
<p class="cast-level">Doctor Emmett Carney—doing the best he can against long odds</p>
<p class="cast-level">Ann Addison (Mrs. Doc)—the local midwife, pressed into service</p>
<p class="cast-level">Nola Thomason—Alice’s neighbor</p>
<p class="cast-level">Homer Thomason—Nola’s husband</p>
<p class="cast-level">Dorothy Thomason—their daughter, Sophronia’s friend</p>
<p class="cast-level">Lewis Hulce—Nola’s son from a previous marriage</p>
<p class="cast-level">JoNell Reed—Lewis’ beloved</p>
<p class="cast-level">Mrs. Gale—Alice’s neighbor</p>
<p class="cast-level">Old Man Escoe—Mrs. Gale’s father, loves cats and children</p>
<p class="cast-level4">Animals:</p>
<p class="cast-level2">Sweet Honey Baby—a horse often involved in criminal activity</p>
<p class="cast-level">Bacon, Charlie Dog, Big Fella, Buttercup, Crook—the family dogs</p>
<p class="cast-level">A half-grown yellow kitten—may be magic</p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Return_of_the_Raven_Mocker-3.vue?9b0eadc8